import HomePage from 'pages/home/Home.page';

export default function App() {
  return (
    <HomePage />
  );
}
